import { Component } from '@angular/core';

@Component({
    selector: 'app-solutionwrapper',
    imports: [],
    templateUrl: './solutionwrapper.component.html',
    styleUrl: './solutionwrapper.component.css'
})
export class SolutionwrapperComponent {

}
